import { jsPDF } from 'jspdf';
import { CONTACT_STATIC } from '../i18n/media';

const fmt = (n) => new Intl.NumberFormat('fr-CH', { maximumFractionDigits: 0 }).format(Math.max(0, Math.round(n)));

// Generates a branded one-page ROI estimate PDF and triggers download.
export function generateRoiPdf({ content, inputs, calc }) {
  const r = content.roi;
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const W = 210;
  const teal = [13, 148, 136];
  const cyan = [6, 182, 212];
  const ink = [11, 18, 32];
  const slate = [100, 116, 139];
  const light = [241, 245, 249];

  // Header band
  doc.setFillColor(...ink);
  doc.rect(0, 0, W, 40, 'F');
  doc.setFillColor(...teal);
  doc.roundedRect(16, 13, 9, 9, 2, 2, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.text('LOGITAG', 29, 20);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.setTextColor(94, 234, 212);
  doc.text(r.pdfDoc, 29, 27);
  const today = new Date().toLocaleDateString(content.lang === 'fr' ? 'fr-CH' : content.lang === 'de' ? 'de-CH' : 'en-CH');
  doc.setTextColor(203, 213, 225);
  doc.setFontSize(9);
  doc.text(`${r.pdfDate} ${today}`, W - 16, 20, { align: 'right' });

  // Title
  doc.setTextColor(...ink);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(r.title, 16, 55, { maxWidth: W - 32 });

  // Inputs box
  let y = 66;
  doc.setFillColor(...light);
  doc.roundedRect(16, y, W - 32, 30, 3, 3, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(...teal);
  doc.text(r.pdfInputs.toUpperCase(), 22, y + 8);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(...slate);
  const inputRows = [
    [r.assets, `${inputs.assets} ${r.unitAssets}`],
    [r.avgValue, `${fmt(inputs.avgValue)} CHF`],
    [r.hours, `${inputs.hours} ${r.unitHours}`],
  ];
  inputRows.forEach((row, i) => {
    const yy = y + 15 + i * 5;
    doc.setTextColor(...slate);
    doc.text(row[0], 22, yy);
    doc.setTextColor(...ink);
    doc.setFont('helvetica', 'bold');
    doc.text(row[1], W - 22, yy, { align: 'right' });
    doc.setFont('helvetica', 'normal');
  });

  // Net savings highlight
  y = 104;
  doc.setFillColor(...ink);
  doc.roundedRect(16, y, W - 32, 34, 3, 3, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(94, 234, 212);
  doc.text(r.resultTitle.toUpperCase(), 22, y + 10);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(30);
  doc.setTextColor(...cyan);
  doc.text(`${fmt(calc.net)} CHF`, 22, y + 24);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.setTextColor(203, 213, 225);
  doc.text(r.perYear, 22 + doc.getTextWidth(`${fmt(calc.net)} CHF`) + 4, y + 24);
  // ROI chip
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(148, 233, 220);
  doc.text(r.roiLabel, W - 22, y + 12, { align: 'right' });
  doc.setFontSize(22);
  doc.setTextColor(94, 234, 212);
  doc.text(`${Math.round(calc.roi)}%`, W - 22, y + 24, { align: 'right' });

  // Breakdown rows
  y = 148;
  const rows = [
    [r.breakdownTime, `${fmt(calc.timeSaved)} CHF`, false],
    [r.breakdownLoss, `${fmt(calc.lossAvoided)} CHF`, false],
    [r.annualSavings, `${fmt(calc.gross)} CHF`, false],
    [r.logitagCost, `\u2212${fmt(calc.cost)} CHF`, false],
    [r.netSavings, `${fmt(calc.net)} CHF`, true],
  ];
  doc.setFontSize(11);
  rows.forEach((row, i) => {
    const yy = y + i * 11;
    if (row[2]) {
      doc.setDrawColor(226, 232, 240);
      doc.line(16, yy - 5, W - 16, yy - 5);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...teal);
    } else {
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...slate);
    }
    doc.text(row[0], 20, yy);
    doc.setTextColor(...(row[2] ? teal : ink));
    doc.setFont('helvetica', 'bold');
    doc.text(row[1], W - 20, yy, { align: 'right' });
  });

  // Footer
  doc.setDrawColor(226, 232, 240);
  doc.line(16, 260, W - 16, 260);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(...slate);
  doc.text(r.disclaimer, 16, 268, { maxWidth: W - 32 });
  doc.setTextColor(...teal);
  doc.text(`${CONTACT_STATIC.email}  \u00b7  ${CONTACT_STATIC.phone}  \u00b7  logitag.ch`, 16, 278);

  doc.save(`LOGITAG-ROI-${today.replace(/[\/.]/g, '-')}.pdf`);
}
